
const digest = 'c009d1852a5114fc3cf2c35bec08096f88d92409197f70ebf0c088f2cc4cc967';
const css = `._codeSnippet_arpso_1 {
  font-family: monospace;
  color: var(--theme-code-text, #d14);
  border: 1px solid var(--theme-primary-border, #e1e1e1);
  padding: 0 4px;
  margin: 0;
  border-radius: 3px;
  background-color: var(--theme-secondary-background, #f7f7f7);
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"codeSnippet":"_codeSnippet_arpso_1"};
export { css, digest };
  